import { CardUIExtension, ICardUIExtensionContext, ICardModel } from 'tessa/ui/cards';
import { Guid } from 'tessa/platform';
import { CdCardTypes } from 'src/cdScripts/Helpers/CdCardTypes';
import { Card } from 'tessa/cards';
import { CdUIHelper } from '../CdUIHelper';
import { CdRequestForMaterialsClientHelper } from 'src/cdScripts/Helpers/Cards/CdRequestForMaterialsClientHelper';
import { CdGeneralDocumentationClientHelper } from 'src/cdScripts/Helpers/Cards/CdGeneralDocumentationClientHelper';
import { CdRequestForMaterialsSharedHelper } from 'src/cdScripts/Helpers/Cards/CdRequestForMaterialsSharedHelper';

export class CdRequestForMaterialsUIExtension extends CardUIExtension {

  private _disposer: Function | null = null;

  public async initialized(context: ICardUIExtensionContext) {
    let model: ICardModel;
    let card: Card;
    if ((model = context.model) == null ||
        (card = context.model.card) == null) {
      return;
    }
    if (!Guid.equals(context.model.card.typeId, CdCardTypes.PkRequestForMaterialsTypeID)) {
    return;
    }
    
    CdUIHelper.InitializeTableObjects(context);    
    CdGeneralDocumentationClientHelper.ApprovementMatchingRolesChanged(model, 'PkApprovementMatching','PkApprovementMatchingRoles');
    CdGeneralDocumentationClientHelper.FieldsObjectsLogic(card,model);
    CdRequestForMaterialsClientHelper.FillApproversLogic(context);
    CdRequestForMaterialsClientHelper.TableOrderLogic(card, context);
    CdRequestForMaterialsClientHelper.TableMaterialsInitialize(context);
  }

  public async saving(context: ICardUIExtensionContext) {
    let card: Card;
    if ((card = context.model.card) == null) {
      return;
    }
    if (!Guid.equals(context.model.card.typeId, CdCardTypes.PkRequestForMaterialsTypeID)) {
      return;
    }     

    await CdGeneralDocumentationClientHelper.CheckApprovementTableOrder(context); //не заменять на context.model.card
    await CdGeneralDocumentationClientHelper.CheckAddedFiles(context,0
      ,CdRequestForMaterialsSharedHelper.ApproverTaskStoreInfo.TaskStartProcessTypesList
      ,CdRequestForMaterialsSharedHelper.ApproverTaskStoreInfo.TaskStartProcessOptionsList
      ,CdRequestForMaterialsSharedHelper.CheckFileCategoryList
      );
    if (await !CdGeneralDocumentationClientHelper.CheckEditSignedFile(card)) {
      context.cancel = true;
    }
    
  }

  public finalized() {
    // подчищаем за собой
    if (this._disposer) {
        this._disposer();
        this._disposer = null;
    }
  }
}